import React from "react";
import { Dictionary } from "lodash";
import { Viewer } from "@/features/auth/graphql/generated";
import { DimensionWithScores } from "@/features/people/hooks/useDimensionsWithScores";
import { PDFDocument, PdfContainer } from "../../generator";
import { PersonSummary } from "./pages/PersonSummary";
import { HighlightsAndPersonality } from "./pages/Highlights";
import { Values } from "./pages/Values";
import { Competencies } from "./pages/Competencies";

interface PersonalProfilePdfProps {
  profile: Viewer;
  summary?: string;
  dimensions: Dictionary<DimensionWithScores[]>;
}

function PersonalProfilePdf(props: PersonalProfilePdfProps) {
  const { dimensions, profile = {} as Viewer, summary } = props;

  if (!profile || !dimensions) return null;

  // Combine all pages
  const pages = [
    <PdfContainer className="relative px-4" key="personal-profile-pdf">
      <PersonSummary profile={profile} summary={summary} />
      <HighlightsAndPersonality dimensions={dimensions} context="user" />
      <Values
        dimensions={dimensions}
        context="user"
        defaultPersonId={profile.id!}
        // person={profile}
      />
      <Competencies
        dimensions={dimensions}
        context="user"
        // person={profile}
        defaultPersonId={profile.id!}
      />
    </PdfContainer>,
  ];

  return <PDFDocument pages={pages} />;
}

export default PersonalProfilePdf;
